import { API_IDS } from '@intigral/constant';
import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';

import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IApiPathManager } from '../config/ApiPathManager';
import { IStreamHarnessRepository } from '../../core/repositories/interfaces/iStreamHarnessRepository';
import {
    IAcquireLockRequestBody,
    IAcquireLockRequestHeaders,
    IAcquireLockRequestParams,
    IAcquireLockResponse,
    IDeleteLockRequestParams,
} from '../../entity/interface/iStreamHarness';

class StreamHarnessRepository implements IStreamHarnessRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async acquireLock(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        const url = this.apiPathManager.getPath(API_IDS.STREAM_HARNESS_ACQUIRE_LOCK);
        const newUrl = params?.publicUrl.replace('?', '&');
        const newParams = { ...params, publicUrl: newUrl };
        const response = await this.http.post<IAcquireLockResponse>(url, {
            params: {
                ...newParams,
            },
            body: {
                ...payload,
            },
            headers: {
                Authorization: headers.authToken,
                identityToken: headers.identityToken,
            },
        });
        return response.data;
    }

    async refreshLock(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        const url = this.apiPathManager.getPath(API_IDS.STREAM_HARNESS_ACQUIRE_LOCK);
        const newUrl = params?.publicUrl.replace('?', '&');
        const newParams = { ...params, publicUrl: newUrl };
        const response = await this.http.put<IAcquireLockResponse>(url, {
            params: {
                ...newParams,
            },
            body: {
                ...payload,
            },
            headers: {
                Authorization: headers.authToken,
                identityToken: headers.identityToken,
            },
        });
        return response.data;
    }

    async deleteLock(
        params: IDeleteLockRequestParams,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        const url = this.apiPathManager.getPath(API_IDS.STREAM_HARNESS_UNLOCK);
        const response = await this.http.delete<IAcquireLockResponse>(url, {
            params: {
                ...params,
            },
            headers: {
                Authorization: headers.authToken,
                identityToken: headers.identityToken,
            },
        });
        return response.data;
    }
}

export default StreamHarnessRepository;
